import React, { useState } from "react";
import NavBar from './NavBar'; // Import the NavBar component
import { Card, Form, Row, Col, Container } from "react-bootstrap"; 
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css"; // Styling leaflet
import L from "leaflet"; // Fix for missing marker icon
import geoJsonData from "./data/indonesia-province-simple.json"; // Ensure this path is correct
import provincesData from "./data/provincesData.json"; // Ensure this path is correct
import DistrictTable from "./components/DistrictTable";
import StuntingBarChart from "./components/StuntingBarChart";


const center = {
  lat: -2.548926, // Center coordinates of Indonesia
  lng: 118.0148634,
};

// Default blue marker icon
const defaultIcon = new L.Icon({
  iconUrl: "/icons/redx.png",
  iconSize: [25, 27],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
});

// Red marker icon for the selected province
const redIcon = new L.Icon({
  iconUrl: "/icons/greenx.png",
  iconSize: [25, 27],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
});

const Dashboard = () => {
  const [selectedProvince, setSelectedProvince] = useState(null);
  const [clickedProvinceId, setClickedProvinceId] = useState(null); // Track which province marker is clicked

  const handleMarkerClick = (province) => {
    setSelectedProvince(province);
    setClickedProvinceId(province.id); // Save the clicked province ID
  };

  return (
    <>
      <Container fluid style={{ display: "flex", justifyContent: "center" }}>
        <div>
          <NavBar />
        </div>
        <div style={{ width: "100%", padding: "1rem" }}>
          <Row>
            <Col md="12">
              <Card>
                <Card.Header>
                  <h3>Dashboard</h3>
                </Card.Header>
                <Card.Body>
                
                    <Row>
                      <Col md="3">
                        {/* Informasi Provinsi di Pojok Kiri Atas */}
                        <Card >
                        {/* <Card style={{ position: "absolute", top: "10px", left: "10px", zIndex: 1000 }}> */}
                          <Card.Body>
                            {selectedProvince ? (
                              <div>
                                <h5>{selectedProvince.name}</h5>
                                {/* <p>{selectedProvince.description}</p> */}
                                <p>Jumlah Kasus Stunting yang terdapat di {selectedProvince.name} adalah: {selectedProvince.stunting_cases.toLocaleString()}</p>
                              </div>
                            ) : (
                              <p>Klik pada marker untuk melihat detail.</p>
                            )}
                          </Card.Body>
                         
                        </Card>

                        <Card style={{  top: "10px" }} >                        
                          <Card.Body>                            
                              <div style={{  textAlign:center }}>
                                <h1>35</h1>                            
                                <p>Total Propinsi</p>
                              </div>                                                          
                          </Card.Body>                         
                        </Card>

                        {/* <Card style={{  top: "20px" }} >                        
                          <Card.Body>                            
                              <div style={{  textAlign:center }}>
                              <DistrictTable/>
                              </div>                                                          
                          </Card.Body>                         
                        </Card>                         */}

                      </Col>
                      <Col md="9">
                        <MapContainer center={center} zoom={5} style={{ width: "100%", height: "600px" }}>
                          {/* TileLayer OpenStreetMap */}
                          <TileLayer
                            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                          />

                          {/* Render Marker berdasarkan data provincesData */}
                          {provincesData.map((province) => (
                            <Marker
                              key={province.id}
                              position={{ lat: province.latitude, lng: province.longitude }}
                              eventHandlers={{
                                click: () => handleMarkerClick(province),
                              }}
                              // Ganti ikon marker menjadi merah jika ID-nya cocok dengan yang diklik
                              icon={clickedProvinceId === province.id ? redIcon : defaultIcon}
                            />
                          ))}
                        </MapContainer>
                      </Col>
                    </Row>
                    {/* <Row>
                    <Col md="12"><DistrictTable/> </Col>
                    </Row> */}
                 
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </div>
      </Container>
    </>
  );
};

export default Dashboard;